import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=60b43e28&scoped=true&"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=60b43e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b43e28",
  null
  
)

export default component.exports